import * as React from "react";
import PropTypes from 'prop-types';

const SvgSuccessCheck = props => {
  if (props.id !== "_svgsuccesscheck") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 40 40" {...props}><path fill="#128A4A" d="M20 0C8.954 0 0 8.954 0 20s8.954 20 20 20 20-8.954 20-20S31.046 0 20 0zm10.991 12.264c.65.65.65 1.706 0 2.357L16.553 29.057a1.662 1.662 0 01-1.178.488c-.427 0-.854-.163-1.179-.488l-4.905-4.906a1.667 1.667 0 012.357-2.357l3.727 3.727 13.26-13.257a1.667 1.667 0 012.356 0z" fillRule="evenodd" /></svg>;
};

SvgSuccessCheck.displayName = "_svgsuccesscheck";
SvgSuccessCheck.propTypes = {
  id: PropTypes.string
};
SvgSuccessCheck.defaultProps = {
  id: ''
};
export default SvgSuccessCheck;